// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import WorkFamilyObject from "classes/Professions/WorkFamilyObject";
import { ConditionalSelect } from "components/Inputs/CustomAsyncSelect/CustomCreatableSelect";
import genRequest from "includes/request";
import { t } from "i18next";
import React from "react";

export default function WorkFamilySelect(props) {
	const { isAdmin } = useAccount();

	function handleAddWFY(new_item) {
		let obj = new WorkFamilyObject({
			workFamilyName: new_item.label,
			companyId: props.companyId
		});
		let req = obj.send().then((resp) => {
			return ({
				label: resp.workFamilyName,
				value: resp.workFamilyId,
				workFamilyId: resp.workFamilyId,
			});
		});
		return (req);
	}

	return (
		<ConditionalSelect
			placeholder={t("WorkFamilies.SELECT_FAM")}
			className={"bg-color w-100 rounded"}
			classNamePrefix="dropdown"
			queryKey={["WorkFamilies", "WorkFamilyOfCompany", props.companyId]}
			queryFn={() => genRequest("work-families/company/" + props.companyId)}
			treat={(wfy) => ({
				value: wfy.id,
				workFamilyId: wfy.id,
				label: wfy.name
			})}
			isSearchable={true}
			onCreateOption={isAdmin() ? handleAddWFY : false}
			{...props}
		/>
	);
}
